import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
// Import only the lightweight manifests here (not the docs registries, which
// would pull every chapter's markdown into the main bundle).
import chapters from "@/docs/manifest";
import manymuxChapters from "@/manymux-docs/manifest";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/manymux",
    name: "manymux",
    component: () => import("../views/ManymuxView.vue"),
  },
  {
    path: "/manymux/docs",
    redirect: () => `/manymux/docs/${manymuxChapters[0].slug}`,
  },
  {
    path: "/manymux/docs/:slug",
    name: "manymux-docs",
    component: () => import("../views/DocsView.vue"),
    props: (route) => ({ slug: route.params.slug, book: "manymux" }),
  },
  {
    path: "/docs",
    redirect: () => `/docs/${chapters[0].slug}`,
  },
  {
    path: "/docs/:slug",
    name: "docs",
    component: () => import("../views/DocsView.vue"),
    props: (route) => ({ slug: route.params.slug, book: "rayfish" }),
  },
  {
    path: "/blog",
    name: "blog",
    component: () => import("../views/BlogListView.vue"),
  },
  {
    path: "/blog/:slug",
    name: "blog-post",
    component: () => import("../views/BlogPostView.vue"),
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) return { el: to.hash };
    return { top: 0 };
  },
});

// Routes are lazy-loaded (DocsView/BlogPostView etc.). After a deploy the old
// chunk hashes are deleted from the CDN, so a still-open tab navigating with the
// previous app.js requests a chunk that now 404s; the dynamic import() rejects
// and <router-view> renders nothing (blank page until a hard refresh). Recover
// by reloading to the target URL, which pulls the fresh index.html + new chunk
// names. A sessionStorage guard prevents an infinite reload loop if the asset is
// genuinely unavailable rather than just stale.
const CHUNK_ERROR =
  /loading (css )?chunk|loading dynamically imported module|importing a module script failed|chunkloaderror|failed to fetch dynamically imported/i;
const RELOAD_KEY = "rf-chunk-reload";

router.onError((error, to) => {
  if (!CHUNK_ERROR.test(error?.message || "")) return;
  const target = to?.fullPath || window.location.pathname;
  if (sessionStorage.getItem(RELOAD_KEY) === target) return; // already retried
  sessionStorage.setItem(RELOAD_KEY, target);
  window.location.assign(target);
});

// Clear the guard once a navigation actually succeeds, so a later stale-chunk
// event (after the next deploy) can recover too.
router.afterEach(() => {
  sessionStorage.removeItem(RELOAD_KEY);
});

export default router;
